import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";

import AuthOnlyLayout from "@/components/layouts/auth-only-layout";
import { LoadingModule } from "@/components/modules/loading";
import { auth0CleanUser } from "lib/auth/utils";
import { SessionStorage } from "@/helpers/session-storage";
import { dd } from "@/helpers/datadog";
import { ERROR_CATEGORIES } from "@/constants/errors";
import { unImpersonate } from "@/hooks/use-impersonate";
import { LocalStorage } from "@/helpers/local-storage";

const LogoutWorkaround = () => {
  const { logout: auth0Logout } = useAuth0();

  useEffect(() => {
    try {
      //clear Session storage
      const SS = new SessionStorage();
      SS.clear();

      // Clear active list id to avoid requesting data for a list which doesn't
      // belong to the user withing the new session.
      const LS = new LocalStorage();
      LS.activeListId = null;

      // make sure that impersination cookie are reset
      unImpersonate();

      auth0Logout({ logoutParams: { returnTo: window.location.origin } });

      setTimeout(() => {
        auth0CleanUser();
        window.location.reload();
      }, 3000);
    } catch (e) {
      dd.rum.error(`${ERROR_CATEGORIES.AUTH}[LOGOUT] - useEffect excpetion`, {
        data: { e: e },
      });
    }
  }, []);

  return <LoadingModule />;
};

const LogoutPage = () => {
  return (
    <AuthOnlyLayout>
      <LogoutWorkaround />
    </AuthOnlyLayout>
  );
};

export default LogoutPage;
